// * IMPORTANT: This file was generated by shadcn. Do not change
// * it manually unless you absolutely know what you are doing.

// * IMPORTANT: If this file is modified, be sure to update the
// * `SheetCollapsibleIndustryOrSkillList` component to match the
// * new badge styles.

import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  // Updated `py-0.5` to `py-1`.
  // Updated `font-semibold` to `font-medium`.
  "inline-flex items-center rounded-full border border-slate-200 px-2.5 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 dark:border-slate-800 dark:focus:ring-slate-300",
  {
    variants: {
      variant: {
        default:
          // Removed `hover:bg-slate-900/80 dark:hover:bg-slate-50/80`.
          // Updated `border-transparent` to `border-slate-400`.
          // Updated `bg-slate-900` to `bg-primary-200`.
          // Updated `text-slate-50` to `text-slate-700`.
          "border-slate-400 bg-primary-200 text-slate-700 dark:bg-slate-50 dark:text-slate-900",
        secondary:
          "border-transparent bg-slate-100 text-slate-900 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
        destructive:
          "border-transparent bg-red-500 text-slate-50 hover:bg-red-500/80 dark:bg-red-900 dark:text-slate-50 dark:hover:bg-red-900/80",
        // Updated `text-slate-950` to `text-slate-700`.
        outline: "text-slate-700 dark:text-slate-50",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
